import styled from 'styled-components';
import Text from '../../../../components/Text';
import SalonSearchSelect from './SalonSearchSelect';

interface BoardHeaderProps {
  refetch : (param?: { shopId?: string }) => void;
}

const BoardHeader = ({ refetch }: BoardHeaderProps) => {
  return (
    <Container>
      <Text variant='H5' style={{ fontWeight: 'bold' }}>
        Support Tickets
      </Text>
      <SalonSearchSelect refetch={refetch} />
    </Container>
  );
};

export default BoardHeader;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 24px;
  background: #fff;
`;
